import z from "zod";

import { HEADING_SIZES } from "./constants";

export const headingDataSchema = z.object({
  name: z.string(),
  suffix: z.string().optional(),
  href: z.string().optional(),
  icon: z
    .string()
    .optional()
    .describe("Optional Lucide icon name shown before the name."),
  size: z.enum(HEADING_SIZES).optional(),
});

export type HeadingDataProps = z.infer<typeof headingDataSchema>;
